import React from 'react';
import { Modal } from 'react-bootstrap';
import { AddIcon, EditIcon, Download2Icon } from 'assets/icons';
import { Pagination } from 'components';
import { Globals } from 'utils';
import { ServicesService } from 'services';
import { ModalDeleteService } from './modal-confirm';
import ModalCreateService from './modal-create-service';

const MODAL = {
  NONE: 0,
  CREATE: 1,
  EDIT: 2,
  DELETE: 3,
};

class Users extends React.Component {

  state = {
    modal: MODAL.NONE,
    selectedItem: null,
    data: [],
    pagination: {
      pages: 1,
      page: 1,
    },
  }

  componentDidMount(): void {
    this.getServices();
  }

  getServices = async (page = 1) => {
    try {
      const res = await ServicesService.get({ page });
      const { data, ...rest } = res as any;

      this.setState({
        data: data,
        pagination: rest,
      });

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  download = async () => {
    try {
      const res: any = await ServicesService.get({ download: true });
      if (!res?.url) return;

      const link = document.createElement('a');
      link.href = Globals.fromStorage(res?.url);
      link.download = 'reporte.xlsx';
      link.target = '_blank';
      link.click();

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  setModal = async (modal: number, item?: any) => {
    if (modal === MODAL.EDIT) await this.setModal(MODAL.NONE);
    this.setState({ modal, selectedItem: item ?? null });
  }

  render() {
    const { modal } = this.state

    return (
      <div id="services">
        <Modal
          id="services-delete"
          show={modal === MODAL.DELETE}
          onHide={() => this.setModal(MODAL.NONE)}
        >
          <ModalDeleteService
            services={this.state.selectedItem}
            onClose={(reload) => {
              this.setModal(MODAL.NONE);
              if (reload) this.getServices();
            }}
          />
        </Modal>

        {[MODAL.CREATE, MODAL.EDIT].includes(modal) ? (
          <ModalCreateService
            service={this.state.selectedItem}
            onClose={(reload) => {
              this.setModal(MODAL.NONE);
              if (reload) this.getServices();
            }}
          />
        ) : (
          <section className="toolbar">
            <button className="add" onClick={() => this.setModal(MODAL.CREATE)}>
              <img src={AddIcon} alt="Agregar" />
              <span>Agregar</span>
            </button>
          </section>
        )}

        <div className="rg-table">
          <div className="rg-table-header">
            <p>Servicios</p>
            <div className="rg-table-actions">
              <button onClick={this.download}>
                <img src={Download2Icon} alt="Descargar" />
                <span>Descargar Excel</span>
              </button>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Especialidad</th>
                <th>Tipo de consulta</th>
                <th>Pago al médico</th>
                <th>Precio</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.map((service: any, index: number) => (
                <tr key={`patient-${index}`}>
                  <td>{service?.specialty?.name}</td>
                  <td>{service?.type?.name}</td>
                  <td>{Globals.formatMiles(service?.doctor_price)}</td>
                  <td>{Globals.formatMiles(service?.price)}</td>
                  <td>
                    <div className="actions">
                      <img
                        src={EditIcon}
                        alt="Editar"
                        title="Editar"
                        onClick={() => this.setModal(MODAL.EDIT, service)}
                      />
                      <span title="Eliminar" onClick={() => this.setModal(MODAL.DELETE, service)}>
                        Eliminar
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!this.state.data.length && (
            <p className="no-items">No se encontraron resultados</p>
          )}
        </div>

        <Pagination
          pages={this.state.pagination.pages}
          active={this.state.pagination.page}
          onChange={this.getServices}
        />
      </div>
    )
  }
}

export default Users;